import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';
import defaultImage from "../../assets/svg/defultImage.svg";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from 'react-router';
import { Modal } from 'react-bootstrap';
import { Circle } from '@mui/icons-material';
import { toast } from 'react-toastify';
import noData from "../../assets/svg/Emptyfile1.svg"
const ConfirmProductsCheck = () => {
  const token = localStorage.getItem("token");
  const { id: orderId } = useParams()
  const [itemStatus, setItemStatus] = useState([])
  const [isChecked, setIsChecked] = useState(false);

  const getOrders = async () => {
    try {
      const response = await axios.get(`${newHost}stuff/get-order-products/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const orders = response.data.data?.products

      let checksData = [];
      try {
        const response = await axios.get(`${newHost}stuff/product-checks/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        checksData = response.data.data?.data
        const checksMap = {};

        checksData.forEach(item => {

          checksMap[item.product_variation_id] = {
            status: item.status,
            notes: item.notes || null,
            order_id: item.id,


          };

        })

        const merged = orders.map((order) => ({
          product_variation_id: order.variation_id,
          main_category_image: order.main_category_image,
          service_name: order.service_name,
          name: order.name,
          status: checksMap[order.variation_id]?.status || "",
          notes: checksMap[order.variation_id]?.notes || null,
          order_id: checksMap[order.variation_id]?.order_id || "",
          quantity: order.qty
        }));




        setItemStatus(merged);
        const isAllChecked = merged.every(item =>
          item.status === "packed" || item.status === "unpacked"
        );

        setIsChecked(isAllChecked);

      }
      catch (error) {
        console.log(error);
      }
    }
    catch (error) {
      console.log(error);
    }

  };

  useEffect(() => {
    getOrders()

  }, [])


  const boxStyle = {
    width: 25,
    height: 25,
    border: "2px solid #D1D5DB",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };


  const handleStatusChange = (id, value) => {
    setItemStatus((prev) =>
      prev.map((item) =>
        item.product_variation_id == id
          ? {
            ...item,
            status: value,
            notes: item.notes,
          }
          : item
      )
    );

  };

  const submitProductStatus = async () => {
    const formData = new FormData();

    itemStatus.forEach((item, index) => {
      formData.append(
        `products[${index}][product_variation_id]`,
        item.product_variation_id
      );

      formData.append(
        `products[${index}][status]`,
        item.status
      );
      formData.append(
        `products[${index}][quantity]`,
        item.quantity
      );
      if (item.notes) {
        formData.append(
          `products[${index}][notes]`,
          item.notes
        );
      }

    })


    try {
      const response = await axios.post(
        `${newHost}stuff/product-checks/${orderId}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }

      );
      toast.success(response.data.message)
      const isAllChecked = itemStatus.every(item =>
        item.status === "packed" || item.status === "unpacked"
      );

      setIsChecked(isAllChecked);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.errors.message)

    }
  };
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [noteValue, setNoteValue] = useState("");

  const openModal = (service) => {
    setCurrentItem(service);
    setNoteValue(service.notes || "");

    setShowModal(true);
  };

  const saveNote = (note) => {
    setItemStatus((prev) =>
      prev.map((item) =>
        item.product_variation_id == currentItem.product_variation_id
          ? {
            ...item,
            notes: note,
          }
          : item
      )
    );



    setShowModal(false);
  };


  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName='custom-modal-campaigns-width'>
        <Modal.Header className='d-flex align-items-center' >
          <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
            ملاحظات علي الادوات في الطلب
          </Modal.Title>

        </Modal.Header>
        <Modal.Body className='m-2' style={{ direction: "rtl" }}>

          <div className="">
            <label id='note'>اكتب ملاحظه</label>
            <textarea value={noteValue} onChange={(e) => setNoteValue(e.target.value
            )} style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={4} className='w-100' placeholder='اضف ملاحظاتك' id="note"></textarea>

          </div>

          <div className="d-flex justify-content-center align-items-center my-5 gap-4">

            <button onClick={() => saveNote(noteValue)} className="btn btn-dark px-4">حفظ الفحص</button>

          </div>
        </Modal.Body>

      </Modal>
      <div className='m-4'>
        <div className="" dir="rtl">
          {itemStatus.length > 0 ?
            <>
              <div className="row g-4 min-vh-100">
                <div className="col-lg-12">
                  <div className=" p-4">
                    <div className="d-flex justify-content-start gap-3 mb-3 px-2">
                      <span className="small fw-bold text-muted">تم</span>
                      <span className="small fw-bold text-muted">لم يتم</span>
                    </div>
                    {itemStatus.map((order) => {

                      const hasAttachment = order?.notes

                      return (
                        <>
                          <div className="d-flex gap-2 align-items-center pt-3">
                            <img className='services-images-url' src={order.main_category_image ? `${newImageUrl}${order.main_category_image}` : defaultImage} alt="" />
                            <h6 className="m-0 main-text-color">
                              {order.service_name}
                            </h6>
                          </div>
                          <div className="d-flex flex-column gap-2">


                            <div
                              key={order.order_id}
                              className="row align-items-center border-bottom py-1"
                            >





                              <div className="col-md-8 col-12 d-flex gap-2 align-items-center">

                                <Checkbox
                                  checked={order.status == "packed"}
                                  onChange={() => handleStatusChange(order.product_variation_id, "packed")}
                                  icon={<div style={boxStyle} />}
                                  checkedIcon={
                                    <div style={{ ...boxStyle, backgroundColor: "#3FBEAC" }}>
                                      <CheckIcon style={{ color: "#fff", fontSize: 18 }} />
                                    </div>
                                  }
                                />

                                <Checkbox
                                  checked={order.status == "unpacked"}
                                  onChange={() => handleStatusChange(order.product_variation_id, "unpacked")}
                                  icon={<div style={boxStyle} />}
                                  checkedIcon={
                                    <div style={{ ...boxStyle, backgroundColor: "#A80101" }}>
                                      <CloseIcon style={{ color: "#fff", fontSize: 18 }} />
                                    </div>
                                  }
                                />
                                <div className="">
                                  <p className="m-0">{order.name}</p>
                                </div>
                              </div>

                              <div className="col-md-4 col-12 d-flex justify-content-end">
                                <div className='position-relative' onClick={() => openModal(order)}>
                                  <img
                                    src={noteIcon}
                                    alt="note"
                                    style={{
                                      width: "24px",
                                      cursor: "pointer",

                                    }}
                                  />
                                  {hasAttachment ? <span style={{ top: 0, right: 0 }} className="position-absolute z-1">
                                    <Circle sx={{ fontSize: "8px", color: "#FF0B0B" }} />
                                  </span> : null}

                                </div>
                              </div>
                            </div>



                          </div>

                        </>
                      )
                    })
                    }
                  </div>
                </div>

              </div>
              <div className="d-flex justify-content-center fixed-footer">
                <button
                  disabled={isChecked}
                  onClick={submitProductStatus}
                  className="btn btn-dark px-5">تأكيد توافر المواد المطلوبه</button>
              </div>

            </>
            :
            <>
              <div className="flex flex-column text-center align-items-center ">

                <img src={noData} alt="no-data" />
                <p style={{ color: "#535353" }} className=''>لا توجد منتجات ليتم فحصها في هذا الطلب.</p>
              </div>

            </>

          }


        </div>
      </div>
    </>
  )
}

export default ConfirmProductsCheck